import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUserPreferences } from "../../config/services/ApiServices";
 
export const fetchUserPreferences = createAsyncThunk('user-preferences/fetch', async () => {
    const response = await getUserPreferences();
    return response;
})
